import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';

const styles = () => ({
  publish: {
    float: 'right',
  },
});

class PublishProgram extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  isDisabled = () => !this.props.isReady;

  render() {
    const tooltipText = this.isDisabled()
      ? `To Publish a Program Please Provide the Required Content`
      : '';
    const { formData, classes } = this.props;
    return (
      <>
        <Tooltip title={tooltipText} placement="left">
          <span className={classes.publish}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.handleClickOpen()}
              disabled={this.isDisabled()}
            >
              {formData.isPublic ? 'Unpublish' : 'Publish'}
            </Button>
          </span>
        </Tooltip>
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            {formData.isPublic ? 'Hide' : 'Show'} Program
          </DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              <b>Are you sure you want to {formData.isPublic ? 'hide' : 'show'} program?</b>
            </Typography>
            <Typography gutterBottom>
              If you {formData.isPublic ? 'hide' : 'show'} program,
              {formData.isPublic
                ? 'it will no longer be visible to GMB customers.'
                : 'it will be visible to GMB customers.'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.props.handlePublic(formData);
                this.handleClose();
              }}
              variant="contained"
              color="primary"
            >
              {formData.isPublic ? 'Hide' : 'Show'}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

PublishProgram.propTypes = {
  formData: PropTypes.shape({}).isRequired,
  isReady: PropTypes.bool.isRequired,
};

export default withStyles(styles)(PublishProgram);
